import useSWRImmutable from 'swr/immutable'
import { axiosFetcher, type AxiosFetcherKey } from '../../utils/api/axios-fetcher'
import { Servers } from '../../utils/api/servers'
import { useEffect, useState } from 'react'

export function useEnsembles (isAuthorized: boolean, accessToken: string | null): Record<string, string> {
  const [ensembles, setEnsembles] = useState<Record<string, string>>({})

  const { data, error } = useSWRImmutable<Record<string, string>, boolean, AxiosFetcherKey>(
    isAuthorized ? [Servers.STRATEGY_GATEWAY, null, 'configuration/ensembles', accessToken, null] : null,
    axiosFetcher,
  )

  useEffect(() => {
    if (data == null || (error === true)) {
      setEnsembles({})
    } else {
      setEnsembles(data)
    }
  }, [data, error])

  return ensembles
}
